<template>
  <v-dialog v-model="dialog" persistent>
    <v-card align="center" class="rounded-card">
      <v-container>
        <div>
          <span 
            class="header-title" 
            :style="`color: ${$partnerACL.getBackgroundColorApp()}`"
          >{{ $t("DetailTicket") }}</span>
        </div>

        <div class="d-flex flex-column text-left mt-4" style="line-height: 1.2;">
          <span class="f-s-sm">{{ routeTitle }}</span>
          <span class="f-s-sm f-bold">{{ origin + ' - ' + destination }}</span>
        </div>

        <div class="dots-line mt-2" style="margin: 0px -12px;"/>

        <div class="mt-2 text-left">
          <span class="f-bold f-s-xs">{{ $t("TheRouteFollowed") }}:</span>
          <timeline-long 
            :route="tripRoute"
          />
        </div>
      
        <div class="dots-line" style="margin: 0px -12px;"/>

        <div class="my-2 text-left">
          <span class="f-bold f-s-xs">{{ $t("ValidForSingleTripOnly") }}</span>
        </div>

        <div>
          <span class="num-135000-v-nd">{{ new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: selectedCurrency,
            minimumFractionDigits: 2
          }).format(price) }}</span>
        </div>

        <div align="center">
          <v-spacer></v-spacer>
          <ac-button 
            :name="$t('Close')" 
            :on-click-handler="clickClose"
          />
        </div>
      </v-container>
    </v-card>
  </v-dialog>
</template>
<script>
import AcButton from "@/components/AcButton.vue";
import TimelineLong from "@/components/TimelineLong.vue";

export default {
  name: "RouteInformation",
  components:{ AcButton, TimelineLong},
  props: {
    routeTitle: {
      /*
        Description message
      */
      type: String,
      // default:"Route 1 Bến Thành - Bến Xe buýt Chợ Lớn"
    },
    price: {
      type: Number,
    },
    orig: {
      /*
        Description message
      */
      type: String,
      // default: "BT",
    },
    dest: {
      /*
        Description message
      */
      type: String,
      // default: "CT",
    },
    origin: {
      /*
        Description message
      */
      type: String,
      // default:"Ben Than"
    },
    destination: {
      /*
        Description message
      */
      type: String,
      // default:"Cho Tho"
    },

    ToOrig: {
      /*
        Description message
      */
      type: Array,
      // default:"Công trường Mê Linh-Thi Sách-Công trường Mê Linh-Tôn Đức Thắng-Hàm Nghi - Phó Đức Chính - Nguyễn Thái Bình - Ký Con - Trần Hưng Đạo-Nguyễn Tri Phương-Trần Phú-Trần Hưng Đạo-Châu Văn Liêm-Hải Thượng Lãn Ông-Trang Tử-Ga Chợ Lớn A"
    },
    ToDest: {
      /*
        Description message
      */
      type: Array,
      // default:"Ga Chợ Lớn A-Lê Quang Sung-Nguyễn Hữu Thận-Phạm Đình Hổ-Tháp Mười-Hải Thượng Lãn Ông-Châu Văn Liêm-Nguyễn Trãi-Nguyễn Tri Phương-Trần Phú-Trần Hưng Đạo -Hàm Nghi-Hồ Tùng Mậu-đường nhánh S2-Tôn Đức Thắng-Hai Bà Trưng-Đông Du-Thi Sách-Công trường Mê Linh"
    },
    RouteCode: {
      type: String,
    },
    expiredNote: {
      type: String,
    },
    validate_close_date: {
      type: String,
    },
    validate_open_date: {
      type: String,
    },
    fareRule: {
      type: Object,
      default: ()=>{
        return {
          max_trip: 0,
          valid_days: 0,
          max_trip_perday: 0,
          selling_open_date: null,
          selling_open_time: null,
          selling_close_date: null,
          selling_close_time: null,
          validate_open_date: null,
          validate_open_time: null,
          expired_after_usage: 0,
          expired_on_same_day: false,
          validate_close_date: null,
          validate_close_time: null
        }
      }
    },
    dialog: {
      /*
        set open dialog
      */
      type: Boolean,
      required: true,
      default: false,
    },
    btnClose: {
      type: Function,
      required: false,
    },
  },
  computed: {
    tripRoute() {
      return this.ToDest == undefined ? [] : this.ToDest[0].trip_route.filter(fx => fx != null)
    },
    selectedCurrency() {
      return this.$store.state.purchaseticket.currency ? this.$store.state.purchaseticket.currency.code : ""
    }
  },
  methods: {
    clickClose() {
      this.$store.commit("moduleUi/ROUTE_INFORMATION", "");
    },
  },
  mounted() {
  },
};
</script>

<style scoped>
.rounded-card {
  border-radius: 15px;
}
.header-title {
  font-weight: bold;
  font-size: 20px;
}

.dots-line {
    border: 1px dashed #ccc;
}

.num-135000-v-nd {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
  color: #fe7e41;
  margin-bottom: 12px;
}

.route-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-bottom: -5px;

  color: #000000;
}
.detail-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  display: flex;
  align-items: center;
  margin-top: -40px;
  margin-bottom: -20px;
  color: #000000;
}

.name-loc {
  font-style: normal;
  font-weight: 700;
  font-size: 26px;
  line-height: 118.88%;
  /* identical to box height, or 31px */

  text-transform: capitalize;

  color: #489e4b;
}

.name-location {
  font-style: normal;
  font-weight: 300;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-transform: capitalize;

  color: #4bb14e;
}

.detail-route {
  margin-top: -10px;
  font-size: 10px;
  color: #4bb14e;
  text-align: center;
}

.valid-until {
  font-size: 14px;
  color: #4bb14e;
  text-align: center;
}
</style>